// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__Bf4iD","rootSuccess":"CompleteLink_rootSuccess__2-171","rootFailure":"CompleteLink_rootFailure__1rwZM","isDisabled":"CompleteLink_isDisabled__1OUGS"};